function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_USERFOLLOWER_REQUEST = "POST_USERFOLLOWER_REQUEST";
export var POST_USERFOLLOWER_SUCCESS = "POST_USERFOLLOWER_SUCCESS";
export var POST_USERFOLLOWER_FAILURE = "POST_USERFOLLOWER_FAILURE";
export var RESET_POST_USERFOLLOWER = "RESET_POST_USERFOLLOWER";
export var postUserFollower = function postUserFollower(userFollower) {
  var endpoint = "userFollowers";
  if (userFollower.id) endpoint += "/".concat(userFollower.id);
  return _defineProperty({
    userFollower: userFollower
  }, CALL_API, {
    types: [POST_USERFOLLOWER_REQUEST, POST_USERFOLLOWER_SUCCESS, POST_USERFOLLOWER_FAILURE],
    endpoint: endpoint,
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(userFollower),
      credentials: "same-origin"
    }
  });
};
export var DELETE_USERFOLLOWER_REQUEST = "DELETE_USERFOLLOWER_REQUEST";
export var DELETE_USERFOLLOWER_SUCCESS = "DELETE_USERFOLLOWER_SUCCESS";
export var DELETE_USERFOLLOWER_FAILURE = "DELETE_USERFOLLOWER_FAILURE";
export var RESET_DELETE_USERFOLLOWER = "RESET_DELETE_USERFOLLOWER";
export var deleteUserFollower = function deleteUserFollower(userFollower) {
  return _defineProperty({
    userFollower: userFollower
  }, CALL_API, {
    types: [DELETE_USERFOLLOWER_REQUEST, DELETE_USERFOLLOWER_SUCCESS, DELETE_USERFOLLOWER_FAILURE],
    endpoint: "userFollowers/".concat(userFollower.id),
    init: {
      method: "DELETE",
      credentials: "same-origin"
    }
  });
};